export class LockScroll {
    static body = document.querySelector('body');

    static lock() {
        this.body.style.overflow = 'hidden';
    }

    static unLock() {
        this.body.style.overflow = 'auto';
    }
}

export function setVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
